import React from 'react';
import useWindowSize from '../../../../hooks/useWindowSize';
import CirclesBackground from '../../../general/circlesBackground';

const LandingMainSectionCircles = () => {
  const [sizeX] = useWindowSize();

  if (sizeX > 700) {
    return (
      <CirclesBackground
        scale={3.4}
        top='115vh'
        size='min(40vw, 50vh)'
        backgroundColor='#402285'
      />
    );
  } else {
    return (
      <CirclesBackground
        scale={2.5}
        top='125vw'
        size='40vw'
        backgroundColor='#402285'
      />
    );
  }
};

export default LandingMainSectionCircles;
